// Product list: add as needed
export const products = [
  {
    slug: "mitolyn",
    name: "Mitolyn",
    affiliateUrl: "https://9d722k28yhyq4oebpduk1d1r6n.hop.clickbank.net",
    desktopPageImageUrl: "/mitolyn/desktop.jpg",
    mobilePageImageUrl: "/mitolyn/mobile.jpg",
  },
  {
    slug: "pinealPure",
    name: "Pineal Pure",
    affiliateUrl: "https://4000fn7bvknqztdc2hgf3j439b.hop.clickbank.net",
    desktopPageImageUrl: "/pinealPure/desktop.jpg",
    mobilePageImageUrl: "/pinealPure/mobile.jpg",
  },
  {
    slug: "aizenpower",
    name: "Aizen Power",
    affiliateUrl: "https://getaizenpower24.com/start/index.php#aff=tts-rgh",
    desktopPageImageUrl: "/aizenpower/desktop.jpg",
    mobilePageImageUrl: "/aizenpower/mobile.jpg",
  },
  {
    slug: "pronailcomplex24",
    name: "Pronail Complex",
    affiliateUrl: "https://pronailcomplex24.com/text.php#aff=tts-rgh",
    desktopPageImageUrl: "/pronailcomplex24/desktop.jpg",
    mobilePageImageUrl: "/pronailcomplex24/mobile.jpg",
  },
  {
    slug: "claritoxpro",
    name: "Claritox Pro",
    affiliateUrl: "https://claritox24.com/text.php#aff=tts-rgh",
    desktopPageImageUrl: "/claritoxpro/desktop.jpg",
    mobilePageImageUrl: "/claritoxpro/mobile.jpg",
  },
  {
    slug: "circo2",
    name: "Circ O2",
    affiliateUrl: "https://www.digistore24.com/redir/538695/tts-rgh/",
    desktopPageImageUrl: "/circo2/desktop.jpg",
    mobilePageImageUrl: "/circo2/mobile.jpg",
  },
];
